import {request} from '@umijs/max';

/** 用户名密码登录 */
export async function usernameLogin(params: Account.UsernameLoginParams) {
  return request<Account.LoginResult>('/api/v1/account/username-login', {
    method: 'POST',
    data: params,
  });
}

/** 企业微信登录 */
export async function wecomLogin(params: Account.WecomLoginParams) {
  return request<Account.LoginResult>('/api/v1/account/wecom-login', {
    method: 'POST',
    data: params,
  });
}

/** 登出 */
export async function logout() {
  return ;
}